import { Expose } from 'class-transformer';
import { Point } from 'geojson';

import { SnModel } from '@lib/common/models';

export class SnCameraDrone extends SnModel {
  @Expose()
  public externalId: string;

  @Expose()
  public geometry: Point;

  @Expose()
  public id: string;

  @Expose()
  public keepHours: number;

  @Expose()
  public name: string;

  @Expose()
  public properties: any;
}
